export default {"src":"/_next/static/media/batteryHealthIcon.86b09027.svg","height":12,"width":6};